import { useState, useEffect } from 'react';
import CommonHeader from '../../components/feature/CommonHeader';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeaturedContent from './components/FeaturedContent';
import WisdomSection from './components/WisdomSection';
import ServiceSection from './components/ServiceSection';
import ProfileSection from './components/ProfileSection';
import MediaSection from './components/MediaSection';
import CTASection from './components/CTASection';
import FAQSection from '../../components/feature/FAQSection';
import CommonFooter from '../../components/feature/CommonFooter';
import HubCards from '../../components/feature/HubCards';

export default function Home() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.dataset.pageSchema = 'person';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
        "@id": "https://butlerbell.jp/#person",
        "alternateName": ["執事ベル"],
        "sameAs": ["https://thebutler.jp/founder/", "https://butler-association.jp/related/butler-bell/", "https://butler-academy.jp/president"],
      "name": "執事ベル",
      "jobTitle": "全日本執事協会 頭取",
      "url": import.meta.env.VITE_SITE_URL || "https://butlerbell.jp",
      "image": `${import.meta.env.VITE_SITE_URL || "https://butlerbell.jp"}/og-image.jpg`,
      "description": "全日本執事協会頭取・執事ベルの公式サイト。20年以上の執事経験を持つプロフェッショナル執事が、本格的なテーブルマナー、おもてなしの心得、VIP対応の極意など、執事の知恵を発信。",
      "knowsAbout": ["執事文化", "おもてなし", "マナー", "ホスピタリティ", "VIP対応", "テーブルマナー", "エチケット"],
      "memberOf": {
        "@type": "Organization",
          "@id": "https://butler-association.jp/#organization",
          "url": "https://butler-association.jp/",
        "name": "全日本執事協会"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "青海2丁目7−4",
        "addressLocality": "江東区",
        "addressRegion": "東京都",
        "postalCode": "135-0064",
        "addressCountry": "JP"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className={`min-h-screen bg-white transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <CommonHeader />
      <main>
        <HeroSection />
        <AboutSection />
        <FeaturedContent />
        <WisdomSection />
        <ServiceSection />
        <ProfileSection />
        <MediaSection />
        <HubCards group="butlerHub" />
        <CTASection />
      </main>
      <FAQSection />
      <CommonFooter />
    </div>
  );
}
